export default __webpack_public_path__ + "assets/ico_pdf-a00c7a5a.svg";